import React from "react";
import Header from "../components/Frontend/Header";
import Footer from "../components/Frontend/Footer";
import FameWall from "../components/Frontend/FameWall";
import Testimonial from "../components/Frontend/Testimonial";
import VideoTuts from "../components/Frontend/VideoTuts";
import WhyLove from "../components/Frontend/WhyLove";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import ReactGA from "react-ga";
import ReactPixel from "react-facebook-pixel";
import Slider from "react-slick";
class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isActive: false,
    };
  }
  handleClick = () => {
    this.setState((prevState) => ({
      isActive: !prevState.isActive,
    }));
  };

  componentDidMount() {
    ReactGA.initialize("UA-157984080-1");
    ReactGA.pageview(window.location.pathname + window.location.search);
    
    // ReactPixel.init("197333187452630");
    // ReactPixel.pageView();
  }
  render() {
    const customslider = {
      dots: false,
      arrows: false,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 4000,
    };
    return (
      <React.Fragment>
        <Helmet>
          <title>PTE Writing Test Practice Material | LA Language Academy</title>
          <meta name="description" content="Enhance your PTE writing skills with LA Language Academy's online practice tests. Get expert strategies, sample tests & improve your exam performance." />
          <meta name="robots" content="index, follow" />
          <link rel="canonical" href={`https://www.languageacademy.com.au/pte-writing-test-practice-material`} />
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:site" content="@languageacademy" />
          <meta name="twitter:title" content="PTE Writing Test Practice Material | LA Language Academy" />
          <meta name="twitter:description" content="Enhance your PTE writing skills with LA Language Academy's online practice tests. Get expert strategies, sample tests & improve your exam performance." />
          <meta name="twitter:image" content={`https://www.languageacademy.com.au/images/logol.png`} />
          <meta name="twitter:image:alt" content="LA Language Academy Logo" />
          <meta property="og:url" content={`https://www.languageacademy.com.au/pte-writing-test-practice-material`} />
          <meta property="og:type" content="website" />
          <meta property="og:title" content="PTE Writing Test Practice Material | LA Language Academy" />
          <meta property="og:description" content="Enhance your PTE writing skills with LA Language Academy's online practice tests. Get expert strategies, sample tests & improve your exam performance." />
          <meta property="og:image" content={`https://www.languageacademy.com.au/images/logol.png`} />
          <meta property="og:image:alt" content="LA Language Academy Logo" />
          <meta property="og:image:width" content="1200" />
          <meta property="og:image:height" content="630" />
        </Helmet>
        <div className="innerPage">
          <Header />
          <div className="hero-section mt-80">
            <div className="container">
              <div className="row">
                <div className="col-lg-8 col-md-8">
                  <div className="hero-content">
                    <h1 className="primary-heading mfw-600">
                      Polish your English <br className="d-none d-md-block" /> Writing skills with
                      <br className="d-none d-md-block" /> the PTE Writing <br className="d-none d-md-block" />
                      Practice Test Material</h1>
                    <p className="sub-heading bold-sub-heading">
                      Get the best PTE writing sample test material
                      <br className="d-none d-md-block" />
                      to enhance your exam preparation
                    </p>
                    <div className="text-center text-md-start">
                      <Link to="/auth/register" className="primary-btn">
                        REGISTER NOW{" "}
                        <img
                          src="/images/web-new-images/right-arrow.svg"
                          alt="LA"
                        />
                      </Link>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-md-4">
                  <div className="hero-img-wrapper">
                    <img
                      className="img-fluid"
                      src="/images/web-new-images/bannerImg.png"
                      alt="LA"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="pte-content-section wrsl-content-section">
            <div className="circle-section">
              <div className="container pte-container">
                <div className="row">
                  <div className="col-md-12">
                    <div className="position-relative">
                      <ul className="m-0">
                        <li>
                          PTE writing test can seem intimidating to the people
                          who have not written any piece of content ever after
                          their school days. Developing excellent writing skills
                          is a gradual process that demands perseverance and
                          consistent practice. After a long break in this
                          crucial process when the aspirants need to pass the
                          writing module of the PTE exam to accomplish their
                          dream of permanent residency in an English speaking
                          country, they feel downcast. If you find yourself in
                          the same situation, don't get disheartened. You can
                          still improve your writing part if you follow an
                          appropriate strategy and prepare religiously using the
                          right PTE writing practice material.
                        </li>
                      </ul>
                    </div>
                    <div className="pte-bottom-content">
                      <div>
                        <div
                          onClick={this.handleClick}
                          className="pte-bottom-header d-flex justify-content-center align-items-center"
                        >
                          <h3 className="m-0">
                            <a
                              href="javascript:void(0)"
                              className="text-decoration-none"
                            >
                              Read More
                            </a>
                          </h3>
                          <img
                            src="/images/web-new-images/icons/bottom-arrow-01.png"
                            alt="LA"
                          />
                        </div>
                        <ul
                          className={`hide-content ${
                            this.state.isActive ? "active" : ""
                          }`}
                        >
                          <li>
                            As there are plenty of PTE writing sample questions
                            and study material available online, it is quite
                            essential to choose the appropriate preparation
                            resources that can help you sail through the exam.
                            To have a proper strategy for your PTE exam practice
                            writing, you can get in touch with the expert
                            trainers and discuss your doubts with them. The
                            experienced tutors can guide you thoroughly on how
                            to utilize the PTE writing material and practice
                            tests for maximum improvement.
                          </li>
                          <li>
                            After finding the right study resources and PTE
                            coaching experts, the preparation for the writing
                            module will not seem daunting anymore. Your focused
                            preparation with the best PTE writing practice test
                            sets will surely drive you to success.
                          </li>
                          <li>
                            <span>
                              Do you also want to hone your English writing
                              skills and searching for the top-notch{" "}
                              <a href={`https://www.languageacademy.com.au/training/centre-parramatta/best-pte-coaching-classes-institute.html`}>
                                PTE coaching classes
                              </a>{" "}
                              that can help you achieve your aim? Give us a call
                              on{" "}
                              <a href="tel:+61426230061" target="blank">
                                +61 426230061
                              </a>{" "}
                              and get the latest PTE academic writing practice
                              test material to boost your preparation.
                            </span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="text-center">
                    <Link to="/auth/register" className="primary-btn">
                      REGISTER NOW{" "}
                      <img
                        src="/images/web-new-images/right-arrow.svg"
                        alt="LA"
                      />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="prepare-section wrsl-card-section">
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <div className="prepare-cards">
                    <div className="position-relative">
                      <Link to="/pte-listening-test-practice-material"></Link>
                      <div className="prepare-card listening-card">
                        <div className="img-wrapper">
                          <img
                            src="/images/web-new-images/icons/language-01.png"
                            alt="LA"
                          />
                        </div>
                        <h2 className="card-title">Listening</h2>
                        <p className="card-description">
                          Start preparing for the listening section using the
                          latest practice material.
                        </p>
                      </div>
                    </div>
                    <div className="position-relative">
                      <Link to="/pte-reading-test-practice-material"></Link>
                      <div className="prepare-card reading-card">
                        <div className="img-wrapper">
                          <img
                            src="/images/web-new-images/icons/language-04.png"
                            alt="LA"
                          />
                        </div>
                        <h2 className="card-title">Reading</h2>
                        <p className="card-description">
                          Get the intensive PTE reading practice material to
                          skyrocket your score.
                        </p>
                      </div>
                    </div>
                    <div className="position-relative">
                      <Link to="/pte-speaking-test-practice-material"></Link>
                      <div className="prepare-card speaking-card">
                        <div className="img-wrapper">
                          <img
                            src="/images/web-new-images/icons/language-03.png"
                            alt="LA"
                          />
                        </div>
                        <h2 className="card-title">Speaking</h2>
                        <p className="card-description">
                          Get the guidance from our experts and remove all the
                          hurdles that you face in PTE speaking test module.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="text-start text-md-center bottom-btn-wrapper">
                    <p className="sub-heading ">
                      Let’s make your learning meaningful and successful!
                    </p>
                    <Link to="/auth/register" className="primary-btn">
                      REGISTER NOW{" "}
                      <img
                        src="/images/web-new-images/right-arrow.svg"
                        alt="LA"
                      />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="exam-pattern-section pte-exam-pattern pcs-exam-pattern py-0">
            <div className="container">
              <div className="row">
                <h2 className="primary-heading text-center">
                  Why People Love <br className="d-block" />
                  <span className="wpl-badge pte-naati-badge text-white">
                    Language Academy
                  </span>
                </h2>
                <p className="sub-heading text-center">
                  We provide the top-rated PTE training to the candidates{" "}
                  <br className="d-none d-md-block" /> to make their career
                  journey smooth
                </p>
                <div className="pattern-cards-outer mb-0">
                  <div className="exam-pattern-cards position-relative">
                    <Slider {...customslider}>
                      <div className="exam-pattern-card">
                        <div className="img-wrapper">
                          <img
                            src="/images/web-new-images/icons/speaking-icon.svg"
                            alt="LA"
                          />
                        </div>
                        <h3 className="card-title">Experienced Trainer</h3>
                        <p>We have Pearson certified faculty members...</p>
                      </div>
                      <div className="exam-pattern-card">
                        <div className="img-wrapper">
                          <img
                            src="/images/web-new-images/icons/speaking-icon.svg"
                            alt="LA"
                          />
                        </div>
                        <h3 className="card-title">Highest Success Rate</h3>
                        <p>
                          Students will get a sure-shot success with the high...
                        </p>
                      </div>
                      <div className="exam-pattern-card">
                        <div className="img-wrapper">
                          <img
                            src="/images/web-new-images/icons/speaking-icon.svg"
                            alt="LA"
                          />
                        </div>
                        <h3 className="card-title">Free Books</h3>
                        <p>
                          Our PTE / NAATI training institute provides free
                          books...
                        </p>
                      </div>
                      <div className="exam-pattern-card">
                        <div className="img-wrapper">
                          <img
                            src="/images/web-new-images/icons/speaking-icon.svg"
                            alt="LA"
                          />
                        </div>
                        <h3 className="card-title">Latest Resources</h3>
                        <p>
                          Making use of the latest technology, we provide...
                        </p>
                      </div>
                      <div className="exam-pattern-card">
                        <div className="img-wrapper">
                          <img
                            src="/images/web-new-images/icons/speaking-icon.svg"
                            alt="LA"
                          />
                        </div>
                        <h3 className="card-title">Online Support</h3>
                        <p>
                          Our experts are always there to help the students
                          through...
                        </p>
                      </div>
                      <div className="exam-pattern-card">
                        <div className="img-wrapper">
                          <img
                            src="/images/web-new-images/icons/speaking-icon.svg"
                            alt="LA"
                          />
                        </div>
                        <h3 className="card-title">
                          3500 + Questions to Practice
                        </h3>
                        <p>
                          We give the students various exercises and practice
                        </p>
                      </div>
                      <div className="exam-pattern-card">
                        <div className="img-wrapper">
                          <img
                            src="/images/web-new-images/icons/speaking-icon.svg"
                            alt="LA"
                          />
                        </div>
                        <h3 className="card-title">Discussion Sessions</h3>
                        <p>
                          During the discussion sessions, Our experienced
                          team...
                        </p>
                      </div>
                      <div className="exam-pattern-card">
                        <div className="img-wrapper">
                          <img
                            src="/images/web-new-images/icons/speaking-icon.svg"
                            alt="LA"
                          />
                        </div>
                        <h3 className="card-title">Affordable Fees</h3>
                        <p>
                          We offer the best PTE and NAATI coaching
                          classNamees...
                        </p>
                      </div>
                      <div className="exam-pattern-card">
                        <div className="img-wrapper">
                          <img
                            src="/images/web-new-images/icons/speaking-icon.svg"
                            alt="LA"
                          />
                        </div>
                        <h3 className="card-title">
                          Real Time Test Environment
                        </h3>
                        <p>
                          We provide several mock tests for reading,
                          listening...
                        </p>
                      </div>
                    </Slider>
                  </div>
                  <div className="text-center">
                    <Link
                      to="/auth/register"
                      className="dark-border primary-btn"
                    >
                      REGISTER NOW{" "}
                      <img
                        src="/images/web-new-images/right-arrow.svg"
                        alt="Register Now"
                      />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Testimonial />
          <VideoTuts />
          <div className="faq-section mt-faq">
            <div className="container">
              <div className="row">
                <h2 className="secondary-heading text-center">
                  Frequently Asked Questions
                </h2>

                <div className="accordion" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="headingOne">
                      <button
                        className="accordion-button"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseOne"
                        aria-expanded="true"
                        aria-controls="collapseOne"
                      >
                        What is the recommended number of PTE mock tests that I
                        should undertake?
                      </button>
                    </h2>
                    <div
                      id="collapseOne"
                      className="accordion-collapse collapse show"
                      aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        It is recommended to take three complete PTE mock tests.
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="headingTwo">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseTwo"
                        aria-expanded="false"
                        aria-controls="collapseTwo"
                      >
                        What is the PTE requirement for canada?
                      </button>
                    </h2>
                    <div
                      id="collapseTwo"
                      className="accordion-collapse collapse"
                      aria-labelledby="headingTwo"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        The minimum PTE score for Bachelor's programs, Advanced
                        Diplomas, and Post Graduate Programs is 60, with a
                        minimum band score of 53. Students with an overall score
                        of 56 and each band score of at least 51 have also been
                        granted study permits.
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="headingThree">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseThree"
                        aria-expanded="false"
                        aria-controls="collapseThree"
                      >
                        What is the duration of a full-length PTE mock test?
                      </button>
                    </h2>
                    <div
                      id="collapseThree"
                      className="accordion-collapse collapse"
                      aria-labelledby="headingThree"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        Around 2 hours. Students can attempt the test in one go
                        or by taking short breaks.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </React.Fragment>
    );
  }
}

export default Home;
